// ======================================================================
// File Name       : userHistoryContent
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import _ from 'lodash';
import * as ActionTypes from '../constants/actionTypes/userHistoryContent';
import { COMPLETION_CONDITION_STR } from '../constants/ContentHistoryConstant';
import { calculateHistogramYAxisMaxValue } from '../utils/ContentUtils';

const initialState = {
  recordNum: 0,
  recordDetailNum: 0,
  contentList: [],
  itemList: [],
  userList: [],
  learningHistoryList: [],
  contentInfo: {
    bySecernId: {},
    allSecernIds: [],
  },
  itemInfo: {
    bySecernId: {},
    allSecernIds: [],
  },
  userInfo: {
    bySecernId: {},
    allSecernIds: [],
  },
  learningHistoryInfo: {
    bySecernId: {},
    allSecernIds: [],
  },
  learningHistoryInfoByContentID: {
    bySecernId: {},
    allSecernIds: [],
  },
  contentType: null,
  dataAffiliationType: null,
  learningEndTimeFrom: null,
  learningEndTimeTo: null,
  // #7386 START
  questionAnswerSummaryList: [],
  drillImplementationStatusList: [],
  // #7386 END
};

export default function userHistoryContent(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.USER_HISTORY_CONTENT_RECEIVE_CONTENT_LIST: {
      const {
        contentList,
        recordNum,
        contentType,
        dataAffiliationType,
        learningEndTimeFrom,
        learningEndTimeTo,
      } = action;
      const { itemList } = state;
      const contentInfo = contentList.reduce(
        (acc, cur) => {
          acc.bySecernId[cur.contentSecernId] = cur;
          acc.allSecernIds.push(cur.contentSecernId);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );
      itemList && itemList.forEach((item) => {
        contentList && contentList.forEach((content) => {
          if (item.contentInfo && content.contentSecernId === item.contentInfo.contentSecernId) {
            item.contentInfo.contentName = content.contentName;
          }
        });
      });

      return {
        ...state,
        ...{ contentList },
        ...{ contentInfo },
        ...{ contentType },
        ...{ dataAffiliationType },
        ...{ learningEndTimeFrom },
        ...{ learningEndTimeTo },
      };
    }
    case ActionTypes.USER_HISTORY_CONTENT_RECEIVE_ITEM_LIST: {
      const {
        itemList,
        recordNum,
        contentType,
        dataAffiliationType,
        learningEndTimeFrom,
        learningEndTimeTo,
      } = action;
      const { contentList, contentInfo } = state;
      const itemInfo = itemList && itemList.reduce(
        (acc, cur) => {
          acc.bySecernId[cur.itemSecernId] = cur;
          acc.allSecernIds.push(cur.itemSecernId);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );
      itemList && itemList.forEach((item) => {
        contentList.forEach((content) => {
          if (item.contentInfo && content.contentSecernId === item.contentInfo.contentSecernId) {
            item.contentInfo.contentName = content.contentName;
          }
        });
      });

      return {
        ...state,
        ...{ itemList },
        ...{ itemInfo },
        ...{ recordNum },
        ...{ contentType },
        ...{ dataAffiliationType },
        ...{ learningEndTimeFrom },
        ...{ learningEndTimeTo },
      };
    }
    case ActionTypes.USER_HISTORY_CONTENT_RECEIVE_EXECUTION_NUMBER: {
      const { learningHistoryList, recordDetailNum } = action;
      const { itemList, itemInfo } = state;

      const learningHistoryInfo = learningHistoryList.reduce(
        (acc, cur) => {
          acc.bySecernId[cur.itemSecernId] = cur;
          acc.allSecernIds.push(cur.itemSecernId);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );

      return {
        ...state,
        ...{ itemList },
        ...{ learningHistoryList },
        ...{ learningHistoryInfo },
        ...{ recordDetailNum },
      };
    }
    case ActionTypes.GET_EACH_ITEM_STATUS_COUNT: {
      const { itemStatusList } = action;
      let eachItemStatusCount = {};
      if (itemStatusList) {
        eachItemStatusCount = itemStatusList.reduce((acc, cur) => {
          if (cur && cur.itemSecernId) {
            acc[cur.itemSecernId] = cur;
          }
          return acc;
        }, eachItemStatusCount);
      }
      return {
        ...state,
        eachItemStatusCount,
      };
    }
    case ActionTypes.USER_HISTORY_CONTENT_RECEIVE_USER_LIST: {
      const { userList } = action;
      const userInfo = userList.reduce(
        (acc, cur) => {
          acc.bySecernId[cur.userSecernId] = cur;
          acc.allSecernIds.push(cur.userSecernId);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );

      return {
        ...state,
        ...{ userList },
        ...{ userInfo },
      };
    }
    case ActionTypes.USER_HISTORY_CONTENT_RECEIVE_GROUP_LIST: {
      const { groupList } = action;
      const groupInfo = groupList.reduce(
        (acc, cur) => {
          acc.bySecernId[cur.groupSecernId] = cur;
          acc.allSecernIds.push(cur.groupSecernId);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );
      return {
        ...state,
        ...{ groupList },
        ...{ groupInfo },
      };
    }
    case ActionTypes.USER_HISTORY_CONTENT_RECEIVE_GROUP_RELATION_LIST: {
      const { groupRelationList } = action;
      return {
        ...state,
        ...{ groupRelationList },
      };
    }

    // #7386 START
    case ActionTypes.EACH_DRILL_ENFORCE_STATUS_SUMMARY: {
      const { drillImplementationStatusList, progressRatioForItemEnd } = action;
      const objMaxActualResultUserCount = _.maxBy(drillImplementationStatusList, (obj) => obj.actualResultUserCount);
      let histogramDataMax = 10;
      if (objMaxActualResultUserCount.actualResultUserCount > 0) {
        histogramDataMax = calculateHistogramYAxisMaxValue(objMaxActualResultUserCount.actualResultUserCount, true); // get nearest 10
      }
      Object.keys(drillImplementationStatusList).map((index) => {
        const entry = drillImplementationStatusList[index];
        if (!Number.isNaN(entry.actualResultType) && parseInt(entry.actualResultType, 10) > 0) {
          entry.actualResultType *= 10; // show up range on x-axis
          entry.columnId = entry.actualResultType; // determine ticks on x-axis
        }
      });

      if (progressRatioForItemEnd !== null) {
        const completionConditionObj = {
          actualResultType: progressRatioForItemEnd,
          columnName: COMPLETION_CONDITION_STR,
          actualResultUserCount: histogramDataMax,
        };
        drillImplementationStatusList.push(completionConditionObj);
      }

      return {
        ...state,
        ...{ drillImplementationStatusList },
        ...{ progressRatioForItemEnd },
        ...{ histogramDataMax },
      };
    }

    case ActionTypes.EACH_QUESTION_ANSWER_CONTENT_SUMMARY: {
      const { questionAnswerSummaryList } = action;
      return {
        ...state,
        ...{ questionAnswerSummaryList },
      };
    }
    // #7386 END

    // #7464 START
    case ActionTypes.USER_HISTORY_CONTENT_RESET_DATA: {
      const { drillImplementationStatusList } = initialState;
      return {
        ...state,
        ...{ drillImplementationStatusList },
      };
    }
    // #7464 END

    default:
      return state;
  }
}
